module.exports = __webpack_public_path__ + "img/new_spotd3.2aa99691.gif";